import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Users, LogOut, Megaphone, Inbox, Shield, Mail } from "lucide-react";
import { useAuth } from "@/lib/auth";
import CheckUpdateButton from "@/components/CheckUpdateButton";

const Item = ({ to, icon: Icon, children, testid }) => (
  <NavLink
    to={to} end={to === "/admin"}
    data-testid={testid}
    className={({ isActive }) =>
      `flex items-center gap-3 px-4 h-12 rounded-md text-sm font-medium transition-colors ${
        isActive ? "bg-velta-ink text-white" : "text-velta-ink hover:bg-velta-bg"
      }`
    }
  >
    <Icon className="w-5 h-5" strokeWidth={1.8} />
    {children}
  </NavLink>
);

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex bg-velta-bg">
      <aside className="w-64 bg-white border-r border-velta-border flex flex-col">
        <div className="h-16 border-b border-velta-border px-5 flex items-center">
          <Link to="/admin" className="flex items-center gap-2.5">
            <svg width="28" height="36" viewBox="0 0 100 130" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
              <path d="M50 2 L92 32 L92 98 L50 128 L8 98 L8 32 Z" fill="none" stroke="#0F1F3D" strokeWidth="4"/>
              <path d="M50 10 L84 36 L84 94 L50 120 L16 94 L16 36 Z" fill="none" stroke="#0F1F3D" strokeWidth="3"/>
              <path d="M28 38 L50 96 L72 38 L62 38 L50 75 L38 38 Z" fill="#2D5594"/>
              <path d="M40 52 L50 80 L60 52 L55 52 L50 67 L45 52 Z" fill="#3BB75A"/>
            </svg>
            <div className="leading-tight">
              <div className="font-heading font-extrabold tracking-tight text-sm text-velta-ink">VELTA</div>
              <div className="font-heading font-medium text-[11px] tracking-[0.2em] text-[#2D5594]">SISTEMI</div>
              <div className="text-[8px] uppercase tracking-[0.25em] text-velta-mute mt-0.5">Admin</div>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          <Item to="/admin" icon={LayoutDashboard} testid="admin-nav-home">Panoramica</Item>
          <Item to="/admin/superadmin" icon={Shield} testid="admin-nav-superadmin">Nuovo cliente</Item>
          <Item to="/admin/clienti" icon={Users} testid="admin-nav-clients">Clienti</Item>
          <Item to="/admin/richieste" icon={Inbox} testid="admin-nav-quotes">Richieste preventivo</Item>
          <Item to="/admin/note-rilascio" icon={Megaphone} testid="admin-nav-releasenotes">Note di rilascio</Item>
        </nav>
        <div className="p-3 border-t border-velta-border">
          <div className="px-4 py-3 text-xs">
            <div className="font-medium text-velta-ink truncate">{user?.name}</div>
            <div className="text-velta-mute truncate">{user?.email}</div>
          </div>
          <CheckUpdateButton variant="sidebar" />
          <Item to="/admin/messaggi" icon={Mail} testid="admin-nav-messages">Messaggi ai locali</Item>
          <button data-testid="admin-logout-btn" onClick={logout} className="w-full flex items-center gap-3 px-4 h-12 rounded-md text-sm font-medium text-velta-ink hover:bg-velta-bg transition-colors">
            <LogOut className="w-5 h-5" /> Esci
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
